import axios from 'axios'
import { ToastErrorGraphQL, ToastError } from '@/utils'
import store from '@/store'

let buildURL = (base, port, path) => {
  return port
    ? `${base}:${port}${path}`
    : `${base}${path}`
}

export const baseURL = process.env.FOB_BACKEND_PORT
  ? `${process.env.FOB_BACKEND_URL}:${process.env.FOB_BACKEND_PORT}${process.env.FOB_BACKEND_PATH}`
  : `${process.env.FOB_BACKEND_URL}${process.env.FOB_BACKEND_PATH}`

export const anchorWheelURL = process.env.ANCHOR_WHEEL_PORT
  ? `${process.env.ANCHOR_WHEEL_URL}:${process.env.ANCHOR_WHEEL_PORT}${process.env.ANCHOR_WHEEL_PATH}`
  : `${process.env.ANCHOR_WHEEL_URL}${process.env.ANCHOR_WHEEL_PATH}`

export const macoURL = process.env.MACO_PORT
  ? `${process.env.MACO_URL}:${process.env.MACO_PORT}`
  : `${process.env.MACO_URL}`

export const macoBackendURL = process.env.MACO_BACKEND_PORT
  ? `${process.env.MACO_BACKEND_URL}:${process.env.MACO_BACKEND_PORT}${process.env.MACO_BACKEND_PATH}`
  : `${process.env.MACO_BACKEND_URL}${process.env.MACO_BACKEND_PATH}`

export const leurisPdfExportServerURL =
  buildURL(
    process.env.EXPORT_SERVER_URL,
    process.env.EXPORT_SERVER_PORT,
    process.env.EXPORT_SERVER_PATH
  )

export const graphql = (request) => {
  return new Promise((resolve, reject) => {
    axios
      .post(anchorWheelURL, request)
      .then(response => {
        if (response.data.errors) {
          // hide loading bar
          store.dispatch('resetLoading')
          ToastErrorGraphQL({
            errors: response.data.errors
          })
          reject()
        } else {
          resolve(response)
        }
      })
      .catch(error => {
        // hide loading bar
        store.dispatch('resetLoading')
        // distignuish between several types of errors
        if (error && error.response && error.response.data && error.response.data.errors) {
          // graphql errors
          ToastErrorGraphQL({
            errors: error.response.data.errors
          })
        } else if (error && error.response && error.response.status === 500) {
          ToastError('Internal Server Error from GraphQL backend')
        } else if (error && !error.response) {
          // network error
          ToastError('GraphQL backed is not started or no internet connection (network error)')
        } else {
          // generic XHR error
          ToastError(error)
        }
        reject(error)
      })
  })
}

const fobAxios = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

const macoAxios = (method, endpoint, payload) => {
  const token = store.getters['tomaner/maco'].token
  return axios.create({
    baseURL: macoBackendURL,
    timeout: 5000,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, max-age=0, must-revalidate, no-store'
    }
  })[method](endpoint, payload)
}

const leurisExportAxios = (method, payload) => {
  const token = store.getters['user/token']

  return axios.create({
    timeout: 5000,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache, max-age=0, must-revalidate, no-store'
    }
  })[method](leurisPdfExportServerURL, payload)
}

export { fobAxios, macoAxios, leurisExportAxios }



// WEBPACK FOOTER //
// ./src/axios/index.js